/**
* HomePage component
* @returns <HomePage />
*/

// Import necessary components
import BannerTitleButton from "../components/BannerTitleButton";
import TitleAndButton from "../components/TitleAndButton";
import SeriesGridContainer from "../components/SeriesGridContainer";
import BoxWithBackgroundContainer from "../components/BoxWithBackgroundContainer";
import { AnimatePresence } from "framer-motion";
import Loader from "../components/Loader";

// Import custom hook for fetching home data
import { useGetHomeDataQuery } from "../redux/apiSlice";

const HomePage = () => {
    // Fetch home data using the custom hook useGetHomeDataQuery
    const {
        data,
        isFetching,
        isLoading,
        isSuccess,
        isError
    } = useGetHomeDataQuery();

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}

            {isSuccess && (
                <>
                    <BannerTitleButton {...data.BannerTitleButtonProps} />

                    <TitleAndButton {...data.TitleAndButtonProps} />

                    <SeriesGridContainer {...data.SeriesGridContainerProps} />

                    <TitleAndButton {...data.TitleAndButtonBottomProps} />

                    <BoxWithBackgroundContainer {...data.BoxWithBackgroundContainerProps} />
                </>
            )}

            {isError && <p>Hubo un error</p>}
        </>
    )
}

export default HomePage